import styled from "styled-components";

export const TableHeader = styled.th`
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  padding: 0px 0px;
  color: ${({ theme }) => theme.table.font.secondary || "#6b7280"};
  letter-spacing: 0.05em;
  background: ${({ theme }) => theme.table.bg.header || "#FAFAFA"};
  border-bottom: 1px solid #e9eaeb;
  vertical-align: middle;

  &.sorting-column {
    cursor: pointer;
    user-select: none;

    &:hover {
      background: ${({ theme }) => theme.table.bg.hover || "#f3f4f6"};
    }
  }

  .sorting-column {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .sorting-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
  }

  .sorting-placeholder {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }

  .header-content {
    display: flex;
    align-items: center;
    gap: 0px;
    font-weight: 500;
    color: #717680;
    font-size: 12px;
    font-style: normal;
    line-height: 18px;
    font-family: "Geist", sans-serif;

    .sorting-order {
      cursor: pointer;
      height: 12px;
      width: 12px;
      opacity: 0.5;
      transition: opacity 0.2s ease;
      stroke: ${({ theme }) => theme.table.font.secondary || "#6b7280"};
      display: flex;
      align-items: center;
      justify-content: center;

      g {
        path {
          stroke: ${({ theme }) => theme.table.font.secondary || "#6b7280"};
          fill: ${({ theme }) => theme.table.font.secondary || "#6b7280"};
        }
      }

      &.active {
        opacity: 1;

        g {
          path {
            stroke: ${({ theme }) => theme.global.color.arrow || "#374151"};
            fill: ${({ theme }) => theme.global.color.arrow || "#374151"};
          }
        }
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  /* Mobile responsive adjustments */
  @media (max-width: 1250px) {
    white-space: nowrap;
    min-width: fit-content;

    /* Ensure headers don't stack vertically */
    display: table-cell;
    vertical-align: middle;
  }

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 12px 8px;
    white-space: nowrap;
    min-width: fit-content;

    .header-content {
      gap: 4px;
      white-space: nowrap;
    }

    &.sorting-column {
      /* Increase touch target for mobile */
      min-height: 44px;
      display: flex;
      align-items: center;
    }
  }

  @media (max-width: 480px) {
    font-size: 10px;
    padding: 10px 6px;
  }
`;
